/* global axios */
import ApiClient from '../ApiClient';

class CallLogReportApi extends ApiClient {
    constructor() {
        super('call_logs', { accountScoped: true });
    }

    getAll(params = {}) {
        return axios.get(`${this.url}/reports`, { params });
    }
}

export default new CallLogReportApi();